export const enum eAccountComponents {
  Login = 'Account.LoginComponent',
  Register = 'Account.RegisterComponent',
  ManageProfile = 'Account.ManageProfileComponent',
  TenantBox = 'Account.TenantBoxComponent',
  AuthWrapper = 'Account.AuthWrapperComponent',
  ChangePassword = 'Account.ChangePasswordComponent',
  PersonalSettings = 'Account.PersonalSettingsComponent',
}
